<template>
  <div class="hot_labels">
    <img :src="label" alt="">
  </div>
</template>

<script>
  import label from "@/assets/img/icon/label.png"
  export default {
    data(){
      return{
        label: label
      }
    }
  }
</script>

<style lang="scss" scoped>
.hot_labels{
  width: 50px;
  height: 20px;
}
</style>